export default __webpack_public_path__ + "static/media/Director, Customer and Patient experience.20d43ac2.docx";